module.exports = __webpack_public_path__ + "static/media/onboarding-distribution-centers.20b4975f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-distribution-centers.png
// module id = 2638
// module chunks = 0